import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createLegalDocumentSection } from "./sections/legal/LegalDocument.js";
import { getPrivacyPage, privacyRoute } from "../config/privacyContent.js";

export function mountPrivacyPage(root) {
  const pageContent = getPrivacyPage();

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--legal";

  const nav = createNav();

  contentLayer.append(nav, createLegalDocumentSection(pageContent), createFooter());

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "privacy",
    sectionMap: {
      legal: privacyRoute("legal"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      legal: contentLayer.querySelector("#legal"),
    },
  };
}
